import { createTracker } from 'usage-tracker';
import Raven from 'raven-js';
import events from 'LearningCenterUI/events.yaml';
import { USAGE_TRACKER_NAMESPACE as APP_NAME } from 'academy-common-lib/constants/general';
import { getPlatform } from 'academy-common-lib/utils/native/nativeAppDetection';
import { withSessionReplay } from 'usage-tracker-session-replay';
import { isLocalProdApp } from 'academy-common-lib/utils/url';
export class UsageTracker {
  constructor() {
    this.hublessTracker = null;
    this.lastScreen = '';
    const tracker = this.trackerCreator({
      events,
      properties: {
        namespace: APP_NAME,
        platform: getPlatform()
      },
      onError: err => {
        Raven.captureException(err);
      }
    });
    this.tracker = isLocalProdApp() ? tracker : withSessionReplay(tracker);
    const standaloneTracker = this.trackerCreator({
      events,
      onError: Raven.captureException.bind(Raven),
      properties: {
        namespace: APP_NAME,
        platform: getPlatform()
      },
      standalone: true
    });
    this.standaloneTracker = isLocalProdApp() ? standaloneTracker : withSessionReplay(standaloneTracker);
    this.externalLinkTracker = this.tracker.clone({});
  }
  get trackerCreator() {
    return createTracker;
  }
  _trackWithTracker(tracker, eventName, eventProps) {
    let props = eventProps;
    if (Object.prototype.hasOwnProperty.call(eventProps, 'screen')) {
      this.lastScreen = eventProps.screen;
    } else if (this.lastScreen) {
      props = Object.assign({}, eventProps, {
        screen: this.lastScreen
      });
    }
    tracker.track(eventName, props);
  }
  _trackWithStandaloneTracker(tracker, eventName, eventProps) {
    let props = eventProps;
    if ('screen' in eventProps) {
      this.lastScreen = eventProps.screen;
    } else if (this.lastScreen) {
      props = Object.assign({}, eventProps, {
        screen: this.lastScreen
      });
    }
    tracker.track('Learning Center', eventName, props);
  }
  setUpHublessTracker(email) {
    this.hublessTracker = this.tracker.clone({
      allowUnauthed: true,
      properties: {
        namespace: APP_NAME
      }
    });
    this.hublessTracker.setProperties({
      hubId: null,
      email
    });
    return this;
  }

  /**
   * @deprecated
   * Use standalone events tracking via `.trackStandalone()` instead.
   * All net-new tracking should be using standalone events instead of the existing events.yaml.
   * See https://git.hubteam.com/HubSpot/LearningCenterUI/issues/8356
   */
  track(eventName, eventProps) {
    this._trackWithTracker(this.tracker, eventName, eventProps);
  }
  trackStandalone(eventName, eventProps) {
    this._trackWithStandaloneTracker(this.standaloneTracker, eventName, eventProps);
  }
  trackExternalLink(eventName, eventProps) {
    this._trackWithTracker(this.externalLinkTracker, eventName, eventProps);
  }
  trackHubless(eventName, eventProps) {
    if (this.hublessTracker) this._trackWithTracker(this.hublessTracker, eventName, eventProps);
  }
  onError(err) {
    console.warn(err);
    Raven.captureException(err);
  }
}
export default new UsageTracker();